<template>
  <div v-if="!typeMeetingLoading" :class="$setClasses">
    <nxt-core-btn :class="[$vClass('btn'), 'nxt-button nxt-button__ghost', $vPrefix('first')]"
                  :title="$t('base.ignoreStep')"
                  type="button"
                  @click="saveTypeMeeting(unset)"></nxt-core-btn>
    <nxt-core-card v-for="(type, index) in formattedTypeMeeting"
                   v-bind:key="index"
                   :class="[$vClass('card'),
          {[$vPrefix('margin-bottom-medium')]: index + 1 !== formattedTypeMeeting.length}]"
                   :title="type.title" @click="saveTypeMeeting(type)">
      <div :class="$vClass('card__body')">
        <div :class="$vClass('card__body__image')">
          <img :alt="type.display_name" v-bind:src="type.img"/>
        </div>
        <p :class="$vClass('card__body__content')" v-html="type.description"></p>
        <div :class="$vClass('card__body__after')">{{ type.text_button || type.display_name }}</div>
      </div>
    </nxt-core-card>
    <nxt-core-btn :class="[$vClass('btn'), 'nxt-button nxt-button__ghost', $vPrefix('last')]"
                  :title="$t('base.ignoreStep')"
                  type="button"
                  @click="saveTypeMeeting(unset)"></nxt-core-btn>
  </div>
  <div v-else>
    <nxt-core-loader sizeLoader="--size-small"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { usePartnerStore } from '../../../store/partnerStore.ts';

export default {
  name: 'TypeMeeting',
  nameClassStyle: 'type-meeting',
  props: {
    field: Object,
    modelValue: String,
  },
  data() {
    return {
      unset: {
        display_name: 'UNSET',
        value: 'UNSET',
        next_step: 'confirm',
      },
    };
  },
  computed: {
    ...mapState(usePartnerStore, [
      'meetTypeAvailable',
      'typeMeeting',
      'isDataSaving',
      'typeMeetingLoading',
    ]),
    formattedTypeMeeting() {
      return this.meetTypeAvailable && Object.entries(this.meetTypeAvailable)
        .map((typeMeeting) => ({
          ...typeMeeting[1],
          ...this.field?.infosTypeMeeting?.[typeMeeting[1].value],
        }));
    },
  },
  async created() {
    try {
      if (!this.meetTypeAvailable) {
        await this.getTypeMeetingAvailable();
      }
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    ...mapActions(usePartnerStore, [
      'postTypeMeeting',
      'getTypeMeetingAvailable',
    ]),
    async saveTypeMeeting(type) {
      try {
        this.$emit(`update:modelValue`, type && type.value);
        await this.postTypeMeeting(type);
      } catch (error) {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.#{$prefixName}type-meeting {
  display: block;

  .#{$prefixName}margin-bottom-medium {
    margin-bottom: var(--nxt-space-medium);
  }

  &__card {
    cursor: pointer;

    &:hover {
      .#{$prefixName}type-meeting__card__body__after {
        color: var(--nxt-color-white);
        text-shadow: var(--nxt-text-shadow-white);
      }
    }

    clear: both;

    &.el-card {
      background-color: #f4f5f7;
      box-shadow: rgba(0, 0, 0, 0.3) 0 1px 10px -1px;
      border: none;

      :deep(.el-card__body) {
        padding: 0;
      }
    }

    &__body {
      &__after {
        font-size: var(--nxt-font-size-large);
        font-weight: var(--nxt-font-weight-bold);
        background-color: var(--nxt-color-primary);
        width: 100%;
        height: 60px;
        margin: 0;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        @include breakpoint(tablet) {
          height: 100%;
          border-top-right-radius: 0;
          border-bottom-left-radius: 0;
        }

        &:focus {
          outline: 0;
        }
      }

      &__image {
        text-align: center;
        padding: {
          top: 20px;
          right: 20px;
          left: 20px;
        };

        img {
          width: 200px;
        }
      }

      &__content {
        margin: 0;
        padding: 20px;
      }
    }

    @include breakpoint(tablet) {
      &__body {
        display: grid;
        gap: var(--nxt-space-medium);
        grid-template-columns: auto 1fr 160px;
        align-items: center;
        font-size: 16px;
        min-height: 240px;

        &__image {
          padding: {
            right: 0;
            bottom: 20px;
          }
        }
      }
    }
  }

  &__btn {
    background-color: transparent;
    float: right;

    &.#{$prefixName}first {
      margin-bottom: var(--nxt-space-small);
    }

    &.#{$prefixName}last {
      position: relative;
      top: 96px;
      margin-top: -46px;
    }
  }
}
</style>
